import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const AlertHexagonFilledIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M11.6643 2.13995C11.8853 2.09451 12.1142 2.09454 12.3352 2.13995C12.6114 2.19683 12.8571 2.34299 13.0735 2.4632L19.8313 6.2171C20.0595 6.34386 20.3269 6.48292 20.5276 6.7005C20.688 6.87452 20.8097 7.08128 20.884 7.30597C20.9769 7.58713 20.968 7.88863 20.968 8.14972V15.5618C20.968 15.8229 20.9768 16.1244 20.884 16.4056C20.8098 16.6304 20.688 16.837 20.5276 17.011C20.3269 17.2288 20.0596 17.3676 19.8313 17.4944L13.0735 21.2484C12.8571 21.3686 12.6115 21.5147 12.3352 21.5716C12.1142 21.617 11.8853 21.6171 11.6643 21.5716C11.3882 21.5146 11.1424 21.3685 10.926 21.2484L4.16919 17.4944C3.94087 17.3676 3.67266 17.2289 3.47192 17.011C3.31159 16.837 3.18972 16.6303 3.11548 16.4056C3.02276 16.1244 3.03149 15.8229 3.03149 15.5618V8.14972C3.03149 7.88864 3.02267 7.58713 3.11548 7.30597C3.18977 7.08124 3.31153 6.87455 3.47192 6.7005C3.67273 6.48266 3.94084 6.34396 4.16919 6.2171L10.926 2.4632C11.1424 2.343 11.3881 2.19689 11.6643 2.13995Z"
        fill="currentColor"
      />
      <path
        d="M12.0088 14.7582C12.4228 14.7582 12.7585 15.0942 12.7588 15.5082C12.7588 15.9224 12.423 16.2582 12.0088 16.2582H12C11.5858 16.2582 11.25 15.9224 11.25 15.5082C11.2503 15.0942 11.5859 14.7582 12 14.7582H12.0088ZM11.25 11.8558V8.20349C11.25 7.78928 11.5858 7.45349 12 7.45349C12.4142 7.45349 12.75 7.78928 12.75 8.20349V11.8558C12.75 12.27 12.4142 12.6058 12 12.6058C11.5858 12.6058 11.25 12.27 11.25 11.8558Z"
        fill="white"
      />
    </svg>
  );
};

export default AlertHexagonFilledIcon;